import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Solía pasar dos horas el sábado buscando actividades en internet. Ahora abro el kit, elijo lo que quiero y en 10 minutos tengo el encuentro armado. Los niños están más participativos que nunca.',
  author: 'Claudia M.',
  role: 'Catequista, Buenos Aires · 3 grupos de niños'
}, {
  quote: 'Las planificaciones completas me cambiaron la vida. Llegás al encuentro sabiendo exactamente qué vas a hacer: el versículo, la dinámica, la oración. Los chicos notan cuando el catequista llega preparado.',
  author: 'Padre Marcos R.',
  role: 'Parroquia San José, Rosario'
}, {
  quote: 'El Kit de Emergencia lo usé el primer domingo que llegaron 8 chicos extra sin aviso. En 5 minutos tenía una dinámica armada y nadie se dio cuenta que no lo tenía planeado.',
  author: 'Valentina F.',
  role: 'Maestra de Escuela Católica, Córdoba'
}];
export function Testimonials() {
  return <section className="py-10 md:py-16 px-4 md:px-6 bg-cream-100" data-id="element-236">
      <div className="max-w-6xl mx-auto" data-id="element-237">
        <div className="text-center mb-8 md:mb-12" data-id="element-238">
          <h2 className="text-xs md:text-sm font-bold uppercase tracking-widest text-gold-600 mb-2" data-id="element-239">
            Lo que dicen quienes ya lo usan
          </h2>
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-navy-900 leading-tight" data-id="element-240">
            Catequistas que pasaron de improvisar a llegar con todo listo
          </h3>
          <div className="w-16 md:w-24 h-1 bg-gold-500 mx-auto mt-4 md:mt-6 rounded-full" data-id="element-241"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-242">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} whileHover={{
          y: -5,
          boxShadow: '0 10px 30px -10px rgba(200,162,74,0.3)',
          borderColor: '#c8a24a'
        }} transition={{
          duration: 0.3,
          delay: i * 0.1
        }} className="bg-white p-5 md:p-8 rounded-2xl shadow-sm border border-cream-200 relative cursor-default" data-id="element-243">
              <div className="flex gap-1 mb-3 md:mb-4" data-id="element-244">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 md:w-5 md:h-5 fill-gold-500 text-gold-500" data-id="element-245" />)}
              </div>
              <p className="text-navy-900/80 italic mb-4 md:mb-6 text-sm md:text-base leading-relaxed" data-id="element-246">
                "{t.quote}"
              </p>
              <div data-id="element-247">
                <p className="font-bold text-navy-900 text-sm md:text-base" data-id="element-248">
                  {t.author}
                </p>
                <p className="text-xs md:text-sm text-navy-900/60" data-id="element-249">{t.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}